import { render, staticRenderFns } from "./updateReminderModal.vue?vue&type=template&id=07f2fd76&"
import script from "./updateReminderModal.vue?vue&type=script&lang=js&"
export * from "./updateReminderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f2fd76')) {
      api.createRecord('07f2fd76', component.options)
    } else {
      api.reload('07f2fd76', component.options)
    }
    module.hot.accept("./updateReminderModal.vue?vue&type=template&id=07f2fd76&", function () {
      api.rerender('07f2fd76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/appointments/components/updateReminderModal.vue"
export default component.exports